"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const merlin_input_stepper_1 = require("@travelnest/merlin.input-stepper");
const autosave_1 = require("../../../../hooks/autosave");
const usePropertyDefaults_1 = require("../../../../hooks/usePropertyDefaults");
const TaskPage_1 = require("../../base/TaskPage");
const Paragraph_1 = require("../../../components/paragraph/Paragraph");
const Section_1 = require("../../../components/section/Section");
const constants_1 = require("../../../../tasks/constants");
const Spacer_1 = require("../../../components/spacer/Spacer");
const validation_1 = require("../../../../hooks/validation");
const HorizontalRule_1 = require("../../../components/horizontal-rule/HorizontalRule");
const initialArrivalTime = '16:00';
const initialDepartureTime = '11:00';
exports.default = (props) => {
    const { property, viewState, update, lastSaved, getterError, updaterError } = (0, autosave_1.useAutoSaveProperty)(props.propertyId);
    (0, validation_1.usePropertyValidation)('check_in', property);
    (0, validation_1.usePropertyValidation)('check_out', property);
    // If check_in or check_out are not set, default them
    (0, usePropertyDefaults_1.usePropertyDefaults)(property, { check_in: initialArrivalTime, check_out: initialDepartureTime }, update);
    return (React.createElement(TaskPage_1.TaskPage, { task: constants_1.Tasks.ARRIVALS_DEPARTURES, property: property, viewState: viewState, lastSaved: lastSaved, getterError: getterError, updaterError: updaterError },
        React.createElement(TaskPage_1.TaskLayout, { width: 50 },
            React.createElement(HorizontalRule_1.HorizontalRule, null),
            React.createElement(Spacer_1.Spacer, { spacing: "large" }),
            React.createElement(TaskPage_1.TaskColumn, null,
                React.createElement(Section_1.Section, { heading: "Arrivals" },
                    React.createElement(Spacer_1.Spacer, { spacing: "small" }),
                    React.createElement(Paragraph_1.Paragraph, { fillParent: "mid" }, "What time can guests arrive at the property from?"),
                    React.createElement(Spacer_1.Spacer, null),
                    React.createElement(merlin_input_stepper_1.TimeInputStepper, { id: "arrival-time-clicker", onClick: (newValue) => update({ check_in: newValue }), value: (property === null || property === void 0 ? void 0 : property.check_in) || initialArrivalTime })),
                React.createElement(Spacer_1.Spacer, null),
                React.createElement(Section_1.Section, { heading: "Departures" },
                    React.createElement(Spacer_1.Spacer, { spacing: "small" }),
                    React.createElement(Paragraph_1.Paragraph, { fillParent: "mid" }, "What time should guests leave the property by?"),
                    React.createElement(Spacer_1.Spacer, null),
                    React.createElement(merlin_input_stepper_1.TimeInputStepper, { id: "departure-time-clicker", onClick: (newValue) => update({ check_out: newValue }), value: (property === null || property === void 0 ? void 0 : property.check_out) || initialDepartureTime }))))));
};
//# sourceMappingURL=ArrivalsAndDeparturesPage.js.map